<template>
  <TWModal
    :show="show"
    :title="$t('ui.envelopes.create.modals.removeTab.title', { tab: tabName })"
    :loading="false"
    @close="close"
  >
    <template slot="content">
      {{ $t('ui.envelopes.create.modals.removeTab.message', { tab: tabName }) }}
    </template>

    <template slot="controls">
      <BaseButton
        @click.native="close"
        variant="invisible"
        data-ec="remove_tab_modal"
        data-et="cancel_button"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>

      <BaseButton
        @click.native="handleRemove"
        variant="danger"
        data-ec="remove_tab_modal"
        data-et="save_button"
      >
        {{ $t('ui.envelopes.create.modals.removeTab.confirm') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script setup>
// @ts-check

import BaseButton from '@/components/library/buttons/BaseButton.vue';
import TWModal from '@/components/tailwind/Modal.vue';
import { ref } from 'vue';

defineProps({
  tabName: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['remove']);

const show = ref(false);
function open() {
  show.value = true;
}
function close() {
  show.value = false;
}

defineExpose({
  open,
  close,
});

async function handleRemove() {
  emit('remove');
  close();
}
</script>
